<div class="login container bg-cinza-dbmax d-flex flex-column justify-content-center h-100 p-2">
  <div class="form-container">
    <div class="logo text-center">
      <img class="w-75" src="assets/logo-branco.png" />
    </div>
    <div class="card-body">
      <form [formGroup]="loginForm" (submit)="submit()">
        <mat-form-field class="w-100">
          <mat-label>E-mail</mat-label>
          <input formControlName="login" matInput type="email">
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>Senha</mat-label>
          <input formControlName="password" matInput type="password">
        </mat-form-field>
        <div *ngIf="error" class='alert alert-danger'>
          {{error}}
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-action-dbmax w-50 mb-3">LOGIN</button> <br />
          <a class="btn btn-link" routerLink="/esqueci-senha">Esqueci a senha</a>
        </div>
        <div class="text-center mt-2 text-white">
          <small>{{appVersion}}</small>
        </div>
      </form>
    </div>
  </div>
</div>
